<script setup>
import { ref, reactive } from 'vue';
import BadgeShape from "@/Shared/BadgeShape";
import {Inertia} from "@inertiajs/inertia";
import PositionCard from "@/Shared/PositionCard";
import Pagination from "@/Shared/Pagination";
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { FunnelIcon } from '@heroicons/vue/24/outline'
import {useForm} from "@inertiajs/inertia-vue3";
import Checkbox from "@/Shared/Inputs/Checkbox";
import { isEmpty } from 'lodash';

let props = defineProps({
    positions: Object,
    positionCategories: Object,
    positionCategoriesCounts: Object,
    countries: Object,
    filteredCategories: Object,
    filteredCountries: Object,
    errors: Object
});

let form = useForm({
    categoryIds: !isEmpty(props.filteredCategories)?props.filteredCategories:[],
    countryIds: !isEmpty(props.filteredCountries)?props.filteredCountries:[],
})

function search() {
    let filters = {}
    if (!isEmpty(form.categoryIds)) {
        filters.category = form.categoryIds
    }
    if (!isEmpty(form.categoryIds)) {
        filters.country = form.countryIds
    }
    Inertia.get(route('position.index', filters))
}

function categoryRemoveSelectedFilter(index) {
    delete form.categoryIds[index];
}
function categoryIsChecked(index) {
    return !!form.categoryIds[index];
}
function countryRemoveSelectedFilter(index) {
    delete form.countryIds[index];
}
function countryIsChecked(index) {
    return !!form.countryIds[index];
}
</script>

<template>
    <div class="w-full relative">
        <h2 class="text-white text-2xl sm:text-4xl font-bold mt-[108px] sm:mt-[146px] mb-[48px] sm:mb-[146px] text-center px-2">Careers</h2>
        <div class="grid grid-cols-12 gap-y-4">
            <div class="col-span-12 sm:col-span-2">
                <span class="text-white">
                </span>

                <div class="hidden sm:block">
                    <span class="text-white text-opacity-60 text-xs uppercase">Department</span>
                    <div class="space-y-1 my-4 text-white text-sm max-h-44 overflow-y-auto">
                        <Checkbox
                            v-for="(category, index) in positionCategories.data"
                            :key="category.id"
                            :label="category.name + ' (' + positionCategoriesCounts[category.id] + ')'"
                            :id="index"
                            :isChecked="categoryIsChecked(index)"
                            @remove-selected-filter="categoryRemoveSelectedFilter"
                            :modelValue="category.id"
                            v-model="form.categoryIds[index]"
                        />
                    </div>
                    <span class="text-white text-opacity-60 text-xs uppercase">location</span>
                    <div class="space-y-1 mt-4 text-white text-sm max-h-44 overflow-y-auto">
                        <Checkbox
                            v-for="(country, index) in countries"
                            :key="country.id"
                            :label="country.name + ' (' + country.count + ')'"
                            :id="index"
                            :isChecked="countryIsChecked(index)"
                            @remove-selected-filter="countryRemoveSelectedFilter"
                            :modelValue="country.id"
                            v-model="form.countryIds[index]"
                        />
                    </div>
                    <button @click.prevent="search" type="button" class="mt-8 px-6 py-2 text-white text-xs bg-wgn-purple-3 rounded-[40px] m-auto w-fit">Apply Filters</button>
                </div>

                <!-- Mobile -->
                <div class="block sm:hidden">
                    <Disclosure as="section" aria-labelledby="filter-heading" class="text-white bg-wgn-blue-1 rounded">
                        <div class="relative py-4">
                            <div class="mx-auto flex space-x-6 px-4 sm:px-6 lg:px-8">
                                <DisclosureButton class="flex justify-between w-full items-center">
                                    <span class="text-white">Filters</span>
                                    <FunnelIcon class="h-4 w-4 text-white" />
                                </DisclosureButton>
                            </div>
                        </div>
                        <DisclosurePanel class="border-t border-white border-opacity-10">
                            <div class="mx-auto px-4 text-sm pb-4">
                                <fieldset class="pt-4">
                                    <span class="text-white text-opacity-60 text-xs uppercase">industry</span>
                                    <div class="space-y-1 mt-4 text-sm">
                                        <Checkbox
                                            v-for="(category, index) in positionCategories.data"
                                            :key="category.id"
                                            :label="category.name + ' (' + positionCategoriesCounts[category.id] + ')'"
                                            :id="index"
                                            :isChecked="categoryIsChecked(index)"
                                            @remove-selected-filter="categoryRemoveSelectedFilter"
                                            :modelValue="category.id"
                                            v-model="form.categoryIds[index]"
                                        />
                                    </div>
                                </fieldset>
                                <fieldset class="pt-4">
                                    <span class="text-white text-opacity-60 text-xs uppercase">location</span>
                                    <div class="space-y-1 mt-4 text-sm">
                                        <Checkbox
                                            v-for="(country, index) in countries"
                                            :key="country.id"
                                            :label="country.name + ' (' + country.count + ')'"
                                            :id="index"
                                            :isChecked="countryIsChecked(index)"
                                            @remove-selected-filter="countryRemoveSelectedFilter"
                                            :modelValue="country.id"
                                            v-model="form.countryIds[index]"
                                        />
                                    </div>
                                </fieldset>
                                <button @click.prevent="search" type="button" class="mt-4 px-6 py-2 text-white text-xs bg-wgn-purple-3 rounded-[40px] m-auto w-full">Apply Filters</button>
                            </div>
                        </DisclosurePanel>
                    </Disclosure>
                </div>
            </div>

            <div class="col-span-12 sm:col-span-10 sm:col-start-4 space-y-3">
                <PositionCard v-for="position in positions.data" :position="position"></PositionCard>
                <pagination class="flex" :meta="positions.meta"/>
            </div>
        </div>
    </div>
</template>
